import { TableUser } from "./Components/TableUser/TableUser";

export const PageUsers = () => {
  return <TableUser />;
};
